<app-receipt
  [display_columns]="display_columns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'CardReturn'"
  [upload_field_text]="'receipt.uploadCardReturn' | translate"
  [validation_schema]="_validation_schema"
  [upload_handler]="upload_files_client"
  [lookupPermanent]="look_today"
  [wasm_split_pattern]="_wasm_split_pattern"
  [callme]="lookup_all"
  [available_filters]="available_filters"
  [get_paginated_data]="get_paginated_data"
></app-receipt>
